import Slide from '@/mixins/Slide'
import store from '@/store'
import HorizontalScroll from '@/components/HorizontalScroll'

export default
{
    mixins: [
        Slide
    ],

    components: {
        HorizontalScroll
    },

    data()
    {
        return {
            currentTag: ''
        }
    },

    computed:
    {
        content()
        {
            return this.$store.slide10
        }
    },

    watch:
    {
        '$store.modalMessage'(modalMessage)
        {
            if (modalMessage === false)
            {
                this.currentTag = ''
            }
        }
    },

    methods:
    {
        hashTag(pos, lineID, tagID)
        {
            return pos + ',' + lineID + ',' + tagID
        },

        openPopinTag({ intro, paragraphs }, current)
        {
            this.currentTag = current
            store.openModal(intro, paragraphs)
        },

        openPopinTitle(id)
        {
            const { intro, paragraphs } = this.content.titles[id].text
            store.openModal(intro, paragraphs)
        }
    }
}
